import { Button, makeStyles } from "@material-ui/core";

const useStyles = makeStyles(theme => ({
  buttonContainer: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-end",
    alignItems: "center"
  },
  margin: {
    marginLeft: theme.spacing(1),
    marginTop: theme.spacing(3)
  }
}));

export default function ContinueButton({
  handleClick,
  isDisabled
}: {
  handleClick?: () => any;
  isDisabled?: boolean;
}): JSX.Element {
  const classes = useStyles();

  return (
    <div className={classes.buttonContainer}>
      <Button
        variant="contained"
        className={classes.margin}
        disabled={isDisabled}
        onClick={handleClick}
      >
        Continue »
      </Button>
    </div>
  );
}
